module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.80006 10.9875C4.80006 7.57016 7.5704 4.79982 10.9878 4.79982C14.4052 4.79982 17.1755 7.57016 17.1755 10.9875C17.1755 14.4049 14.4052 17.1753 10.9878 17.1753C7.5704 17.1753 4.80006 14.4049 4.80006 10.9875ZM10.9878 2.99976C6.57625 2.99976 3 6.57601 3 10.9875C3 15.3991 6.57625 18.9753 10.9878 18.9753C12.8692 18.9753 14.5986 18.3249 15.9636 17.2366L19.4639 20.7369C19.8154 21.0884 20.3852 21.0884 20.7367 20.7369C21.0882 20.3854 21.0882 19.8156 20.7367 19.4641L17.2365 15.9638C18.325 14.5988 18.9756 12.8691 18.9756 10.9875C18.9756 6.57601 15.3993 2.99976 10.9878 2.99976Z",
      "fill": "black",
      "fill-opacity": "0.2"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b36e00d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b36e00d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/MagnifyingSearch.vue
// module id = 1487
// module chunks = 159